import { render, staticRenderFns } from "./RenewSubscription.vue?vue&type=template&id=bd54b362&"
import script from "./RenewSubscription.vue?vue&type=script&lang=js&"
export * from "./RenewSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports